<div class="new">
<rtn-home-header></rtn-home-header>
<div class="marketing-portal clear-both" [class.has-download]="_systemData.localStorage.getItem('app_download_ignore') === '0'" role="main">
  <router-outlet></router-outlet>
</div>
<rtn-home-footer></rtn-home-footer>
</div>
